import { render, staticRenderFns } from "./StudentWorkReview.vue?vue&type=template&id=fb6fce9c&scoped=true&"
import script from "./StudentWorkReview.vue?vue&type=script&lang=js&"
export * from "./StudentWorkReview.vue?vue&type=script&lang=js&"
import style0 from "./StudentWorkReview.vue?vue&type=style&index=0&id=fb6fce9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6fce9c",
  null
  
)

export default component.exports